/* global ajaxVars */

export default class Footer {
	static updateNewsletterWidget() {
		const $nonce = ajaxVars.nonce;
		var $widget = $('#footer .mc4wp-form');
		var $form = $('#footer form.mc4wp-form');
		var $email = $widget.find('input[name=EMAIL]');
		var $button = $widget.find('input[type=submit]');
		var $inputGroup = $('<div class="input-group"><div class="input-group-append position-absolute"></div></div>');
		$widget.find('.content-block-sm p').addClass(['font-size-normal', 'font-weight-bold', 'text-gc-watermark']);
		$email.addClass(['form-control', 'border-0', 'rounded-pill']);
		$email.removeAttr('required');
		$email.prependTo($inputGroup);
		$button.appendTo($inputGroup.find('.input-group-append'));
		$button.replaceWith('<button class="btn btn-giving-green border-0 rounded-circle font-size-normal" type="submit"><span class="material-symbols-outlined">arrow_upward</span></button>');
		$widget.find('.mc4wp-form-fields').append($inputGroup);
		$form.on('submit', (e)=>{
			e.preventDefault();
			$.ajax(
				{
					type: 'post',
					url: '/api/newsletter/subscribe',
					data: {
						email: $email.val(),
						tag: 'footer',
					}
				}
			).then((res)=>{
				let $successMsg = 'Thank you, your sign-up request was successful! Please check your email inbox to confirm.';
				$form.html(`<div class="mc4wp-response"><div class="mc4wp-alert mc4wp-success"><p>${$successMsg}</p></div></div>`);
			}).catch((err)=> {
				let $errMsg = 'Oops. Something went wrong. Please try again later.';

				if (err.status === 422) {
					$errMsg = Object.values(err.responseJSON.errors)[0] || $errMsg;
				}

				$('#footer .mc4wp-response').html(`<div class="mc4wp-alert mc4wp-error"><p>${$errMsg}</p></div>`);
			})
		});
	}
}
